import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Modal,
  Input,
} from '../../../components/index';
import {
  doPut,
  requestExigencias,
  requestMotivos,
} from '../../../utils/requests';
import { tiposExigenciaSistema } from '../../../utils/constants';

class ModalRejeicaoRequerimento extends Component {
  constructor(props) {
    super(props);
    const state = this.getInitialState();
    if (props.requerimento) {
      state.requerimento = props.requerimento;
    }
    this.state = state;
  }

  getInitialState = () => {
    const initialState = {
      requerimento: {
        exigencias: [],
        justificativaRejeicao: null,
      },
    };
    return initialState;
  }

  componentDidMount() {
    this.buscaDadosDeDominio();
  }

  componentDidUpdate(prevProps) {
    // Preenche requerimento se requerimento for alterado
    if (this.props.requerimento &&
      this.props.requerimento.protocolo !== prevProps.requerimento.protocolo) {
      this.atualizaRequerimento();
    }
  }

  atualizaRequerimento = () => {
    const { requerimento } = { ...this.props };
    this.setState({ ...this.state, requerimento });
  }

  handleChange = (changeObj, name) => {
    this.setState({
      requerimento: {
        ...this.state.requerimento,
        [name]: changeObj.value,
      },
    });
  }

  trataSucessoResponseEnvio = () => {
    this.props.handleRejeicaoRequerimentoSent();
  }

  trataErrosResponse = (error) => {
    // eslint-disable-next-line
    console.log(error);
  }

  diffRequerimento = (tipoRequerimento) => {
    if (tipoRequerimento === 2) {
      return 'pensao';
    }
    return 'aposentadoria';
  }

  handleSave = () => {
    const { requerimento } = { ...this.state };
    const { acao } = { ...this.props };
    const { rejeitar } = { ...this.props };
    const tipo = this.diffRequerimento(this.props.tipoRequerimento);

    requerimento.estado = 14;
    if (acao === 'salvarERejeitar') {
      this.props.handleSalvarERejeitar(this.state.requerimento.motivo, this.state.requerimento.justificativaRejeicao);
    } else {
      let url = `requerimentos-compensacao-${tipo}/${requerimento.protocolo}`;
      if (rejeitar) {
        url = `requerimentos-compensacao-${tipo}/rejeitar/${requerimento.protocolo}`;
      }
      doPut(url, requerimento, this.trataSucessoResponseEnvio, this.trataErrosResponse);
    }
  }

  filtraExigencias = () => {
    if (this.props.requerimento.exigencias) {
      return this.props.requerimento.exigencias
        .filter(exigencia => (!tiposExigenciaSistema.includes(exigencia.tipo)));
    }
    return '';
  }

  handlePositionalChange = (changeObj, name, tipoExigencia) => {
    // console.log(tipoExigencia);
    const listaExigenciasModificada = this.state.requerimento.exigencias.map((exigencia, index) => {
      if (tipoExigencia === exigencia.tipo) {
        const exigenciaAlterada = this.state.requerimento.exigencias[index];
        exigenciaAlterada[name] = changeObj.value;
        let atendida = 0;
        if (exigenciaAlterada.motivoNaoAtendimento !== 0 || exigenciaAlterada.comentarioNaoAtendimento !== '') {
          atendida = 2;
        }
        exigenciaAlterada.atendida = atendida;
        return exigenciaAlterada;
      }
      return this.state.requerimento.exigencias[index];
    });
    this.setState({
      requerimento: {
        ...this.state.requerimento,
        exigencias: listaExigenciasModificada,
      },
    });
  }

  doRequest = (typeRequest) => {
    switch (typeRequest) {
      case 'exigencia':
        if (this.props.exigencias.length === 0) {
          requestExigencias(this.failCallback);
        }
        break;
      case 'motivo':
        if (this.props.motivosRejeicao.length === 0) {
          requestMotivos(this.failCallback);
        }
        break;
      default:
        break;
    }
  }

  buscaDadosDeDominio = () => {
    if (this.props.motivosRejeicao.length === 0) {
      this.doRequest('motivo');
      return null;
    }
    return null;
  }

  retornaTamanhoExigencias = () => {
    let colecao = [];
    if (this.props.requerimento.exigencias) {
      colecao = this.props.requerimento.exigencias
        .filter(exigencia => (!tiposExigenciaSistema.includes(exigencia.tipo)));
    }
    return colecao.length;
  }

  recuperarListaMotivos() {
    const { acao } = { ...this.props };
    // ACAO IGUAL A UNDEFINED VEIO DA TELA DE CONSULTA DE EXIGENCIAS, RECUPERAR O SOLIC. E O DESTINATARIO DO OBJ REQUERIMENTO
    let isSolicitanteRGPS = this.props.requerimento.solicitante === '01000';
    let isDestinatarioRGPS = this.props.requerimento.destinatario === '01000';
    if (acao === undefined || this.props.rejeitar) {
      isSolicitanteRGPS = this.props.requerimento.solicitante.codigo === '01000';
      isDestinatarioRGPS = this.props.requerimento.destinatario.codigo === '01000';
    }

    const rgpsNaRelacao = (isSolicitanteRGPS || isDestinatarioRGPS) ? 1 : 2;
    const reqRegimeAplicado = isSolicitanteRGPS ? 1 : 2;

    const motivosRejeicaoFiltrados = [];
    this.props.motivosRejeicao.forEach((motivo) => {
      if ((motivo.regimeAplicavel === 3 || motivo.regimeAplicavel === reqRegimeAplicado) &&
        (motivo.abrangenciaAplicavel === this.props.tipoRequerimento) &&
        (motivo.acordoAplicavel === 3 || motivo.acordoAplicavel === rgpsNaRelacao)) {
        motivosRejeicaoFiltrados.push(motivo);
      }
    });

    return motivosRejeicaoFiltrados;
  }

  modalRejeicaoRequerimentoContent = () => (
    <div className="row">
      <Grid cols="12 12 12 12">
        <Input
          number
          itemList={this.recuperarListaMotivos()}
          label="Motivo da rejeição"
          onChange={e => this.handleChange(e, 'motivo')}
          placeholder="Selecione o Motivo"
          value={this.state.requerimento.motivo}
          custom
        />
      </Grid>
      <Grid cols="12 12 12 12">
        <Input
          cols="80"
          componentClass="textarea"
          label="Justificativa"
          maxlength="630"
          onChange={e => this.handleChange(e, 'justificativaRejeicao')}
          rows="5"
          value={this.state.requerimento.justificativaRejeicao}
          textarea
        />
      </Grid>
    </div>
  )

  modalRejeicaoRequerimentoFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          hint="Rejeitar o requerimento"
          onClick={this.handleSave}
          title="Confirmar"
        />
      </div>
    </React.Fragment>
  )

  handleClose = () => {
    this.props.handleModal('showRejeicaoRequerimentoModal');
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalRejeicaoRequerimentoFooter()}
        conteudomodal={this.modalRejeicaoRequerimentoContent()}
        onHide={this.handleClose}
        size="md"
        showModal
        title="Rejeição do Requerimento"
      />
    );
  }
}

ModalRejeicaoRequerimento.propTypes = {
  acao: PropTypes.string.isRequired,
  requerimento: PropTypes.objectOf(PropTypes.object).isRequired,
  tipoRequerimento: PropTypes.objectOf(PropTypes.object).isRequired,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  handleChange: PropTypes.func,
  handleRejeicaoRequerimentoSent: PropTypes.func,
  handleSalvarERejeitar: PropTypes.func,
  motivosRejeicao: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  rejeitar: PropTypes.bool,
}.isRequired;

const mapStateToProps = state => ({
  motivosRejeicao: state.base.motivosRejeicao,
});

export default connect(mapStateToProps)(ModalRejeicaoRequerimento);




// WEBPACK FOOTER //
// ./src/pages/consultas/Exigencia/ModalRejeicaoRequerimento.jsx